import React, { useState } from 'react';
import styled from 'styled-components';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import FeedbackDashboardFilterSelect from 'shared/components/Feedback/FeedbackDashboardFilterSelect';
import { Button, FormGroup, Tooltip } from '@mui/material';
import { faFolderGrid } from '@fortawesome/pro-light-svg-icons';
import { Checkbox, ListItemText } from '@mui/material';
import { distance } from 'fastest-levenshtein';
import SearchFeild from 'shared/components/Feedback/FiltersDropdown/SearchField';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { filter } from 'lodash';

interface FilterSelectProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filters: any[];
  className?: string;
  handleFilter: React.Dispatch<React.SetStateAction<number[]>>;
  label: string;
  property: string;
  selected: number[];
}
// If this number is set too high, the searchbar stops working
const PAGE_COUNT = 25;

const FilterSelector = ({ filters, className, handleFilter, label, property, selected }: FilterSelectProps) => {
  const [page, setPage] = useState<number>(1);
  // const [slicedRows, setSlicedRows] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const filteredRows = (searchTerm) ? filters.filter(d => d.name.toLowerCase()
    .includes(searchTerm.toLowerCase()) ||
    distance(d.name.toLowerCase(), searchTerm.toLowerCase()) <= 1).sort((a, b) => {
      const distanceA = distance(a.name.toLowerCase(), searchTerm.toLowerCase());
      const distanceB = distance(b.name.toLowerCase(), searchTerm.toLowerCase());
      return distanceA - distanceB;
    }) : filters;
  const slicedRows = filteredRows.slice(0, page * PAGE_COUNT);
  const RowComponent = ({ onClick, checked, text }: { onClick: () => void; checked: boolean; text: string }) => (
    <RowStyled style={{ display: 'flex', alignItems: 'center' }} onClick={onClick}>
      <Checkbox checked={checked} />
      <ListItemText primary={text} />
    </RowStyled>
  );
  const handleCheckboxChange = (id: number) => {
    handleFilter(prev => 
      prev.includes(id)
      ? prev.filter(d => d !== id)
      : [...prev, id]
    );
  };
  const handleClose = () => {
    setSearchTerm('');
    setPage(1);
  };
  const clearAll = () => {
    handleFilter([]);
  };

  const Component = (property: string
  ) => (
    <FormGroup>
      <SearchFeild
        value={searchTerm}
        size="small"
        placeholder="Search"
        onChange={setSearchTerm}
      />
      {slicedRows.map(d => (
        <RowComponent
          key={d[property]}
          onClick={() => handleCheckboxChange(d[property])}
          checked={selected.includes(d[property])}
          text={`${d.name} - (ID: ${d[property]})`}
        />
      ))}
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button onClick={() => setPage(page + 1)} disabled={filteredRows.length <= page * PAGE_COUNT}>
          Load More
        </Button>
      </div>
    </FormGroup>
  );
  return (
    <FeedbackDashboardFilterSelect
      type="select"
      selectorLabel={label}
      icon={faFolderGrid}
      className={className}
      onClose={handleClose}
      onClearAll={clearAll}
      clearButtonText="Clear All"
      disableClearButton={selected.length === 0}
      children={Component(property)}
      Component={undefined}
    />
  );
};

const RowStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: calc(100vw - 32px); /* Adjust the value as needed */
  overflow-x: auto;
  white-space: nowrap;
  &:hover {
    transition: color 0.1s ease-in-out, background-color 0.1s ease-in-out;
    background-color: ${COLORS.greyDark}; 
    color: ${COLORS.whiteBase};
  }
  &:hover .MuiCheckbox-root {
    color: ${COLORS.whiteBase};
  }
`;

const Pill = styled.div`
  disaply: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${COLORS.whiteBase};
  color: ${COLORS.blackBase};
  line-height: 1;
        border-radius: 50px;
        display: flex;
        flex-shrink: 0;
        align-items: center;
        padding: ${SPACERS.tiny} ${SPACERS.small};
        gap: ${SPACERS.tiny};
        svg {
          cursor: pointer;
          path {
            fill: inherit;
          }
        }
`;

export default FilterSelector;